import { Component, OnInit } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss']
})
export class InformesComponent implements OnInit {

  persons: any = [];

  dtOptions: DataTables.Settings = {};
  constructor(private rest: RestService) { }

  ngOnInit() {
    this.getdata();
    this.dtOptions = {
      responsive: true,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      }
    };
  }

  getdata() {
    this.rest.getsala('gorrion')
      .subscribe((data) => {
        this.persons = data;
      });
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }
}
